// public/js/passwordVisibilityToggle.js

const togglePasswordVisibility = (toggleButtonId, passwordInputId, eyeIconId, eyeSlashIconId) => {
    const toggleButton = document.getElementById(toggleButtonId);
    const eyeIcon = document.getElementById(eyeIconId);
    const eyeSlashIcon = document.getElementById(eyeSlashIconId);

    if (!toggleButton) {
        return // No Element.
    }

    toggleButton.addEventListener('click', () => {
        const passwordInputs = document.querySelectorAll(passwordInputId);
        
        passwordInputs.forEach(passwordInput => {
            const type = passwordInput.type === 'password' ? 'text' : 'password';
            passwordInput.type = type;

            // Toggle visibility of SVGs
            if (type === 'password') {
                eyeSlashIcon.style.display = 'none';
                eyeIcon.style.display = 'inline';
            } else {
                eyeIcon.style.display = 'none';
                eyeSlashIcon.style.display = 'inline';
            }
        });
    });
};

// Initialize password and confirm password visibility toggles
const initializePasswordVisibility = () => {
    // Toggle visibility for main password
    togglePasswordVisibility('toggle-password', '#password', 'eye-icon', 'eye-slash-icon');
    
    // Toggle visibility for confirm password
    togglePasswordVisibility('toggle-confirm-password', '#password_confirmation', 'confirm-eye-icon', 'confirm-eye-slash-icon');
};

document.addEventListener('DOMContentLoaded', initializePasswordVisibility);

export { togglePasswordVisibility, initializePasswordVisibility };
